import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { FormFeedback, Input } from 'reactstrap';
import CommonAction from 'store/common-resource/actions';
import FabricOrderAction from 'store/fabric-order-resource/actions';
import ReadOnlyInput from './ReadOnlyInput';

function SelectcompanyName(props) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)
  const { validation, edit, detail, detailIndex, addDetails } = props
  const { setFieldValue, handleBlur, handleChange, values, errors, touched } = validation

  React.useEffect(() => {
    dispatch(CommonAction.getIgarashiInfo(callbackGetDetailIgarashi))
  }, [])

  const callbackGetDetailIgarashi = (data) => {
    console.log(data)
  }

  const onChange = (e) => {
    if (e) {
      dispatch(FabricOrderAction.getList({ id: values.tradingCompanyId, customerName: e.label }))

      setFieldValue(`details.${detailIndex}.customerId`, e.value)
      setFieldValue(`details.${detailIndex}.companyName`, e.label)

      if (e.value == store.common.igarashiInfo.data.name) {
        dispatch(FabricOrderAction.getListBrand({ id: values.tradingCompanyId }))
        setFieldValue(`details.${detailIndex}.isIgarashi`, true)
      } else {
        setFieldValue(`details.${detailIndex}.isIgarashi`, false)

      }
    } else {
      dispatch(FabricOrderAction.getList({ id: values.tradingCompanyId }))
      setFieldValue(`details.${detailIndex}.customerId`, '')
      setFieldValue(`details.${detailIndex}.companyName`, '')
      setFieldValue(`details.${detailIndex}.brand`, '')
      setFieldValue(`details.${detailIndex}.bunch`, '')
      setFieldValue(`details.${detailIndex}.fabricId`, '')
      setFieldValue(`details.${detailIndex}.fabricNumber`, '')
      setFieldValue(`details.${detailIndex}.numberOfOrders`, '')
      setFieldValue(`details.${detailIndex}.unitPrice`, '')

    }
    addDetails(detailIndex)
  }

  if (detail.activeColumn == 1 || edit) {
    return <ReadOnlyInput value={detail.companyName} />
  }



  return (
    <>
      <Select
        isLoading={store.fabricOrder.customer.loading}
        isDisabled={detail.activeColumn == 1 || edit}
        options={store.fabricOrder.customer.data.map(i => ({ value: i, label: i }))}
        defaultValue={{
          value: detail.customerId,
          label: detail.companyName
        }}
        value={{
          value: detail.customerId,
          label: detail.companyName
        }}
        onChange={onChange}
        isClearable
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
      <Input
        name="companyName"
        className="form-control d-none"
        type="text"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.companyName || ""}
        invalid={
          (touched?.details && errors?.details) ?
            (touched?.details[detailIndex]?.companyName && errors?.details[detailIndex]?.companyName
              ? true
              : false) : false
        }
      />
      {touched?.details && errors?.details ? (
        <FormFeedback type="invalid">
          {errors?.details[detailIndex]?.companyName}
        </FormFeedback>
      ) : null}


    </>
  );
}

export default SelectcompanyName;